export default function PHP_array_reduce() {
  return (
    <div>
      <h1>PHP_array_reduce</h1>
    </div>
  );
}
